export const MAX_INSTALLMENTS = 6

export interface InstallmentSplit {
  first: number
  other: number
  remaining: number
}

/** Split total ILS amount across N installments (Tranzila hosted-fields formula). */
export function splitInstallmentAmount(amount: number, installments: number): InstallmentSplit {
  const other = Math.trunc(amount / installments)
  const first = amount - other * (installments - 1)
  return { first, other, remaining: installments - 1 }
}

/** Extra charge params for Tranzila `payment_plan: 8` (regular installments). */
export function buildInstallmentChargeFields(amount: number, installments: number) {
  if (installments <= 1) return {}
  const { first, other } = splitInstallmentAmount(amount, installments)
  return {
    payment_plan: 8 as const,
    total_installments_number: installments,
    first_installment_amount: first,
    other_installments_amount: other,
  }
}
